import { IExtendedLeftRightSectionProps } from "./ExtendedLeftRightSection";

export const View = (props: IExtendedLeftRightSectionProps) => {
  return (
    <div className="extended-LR">
      <div className="left-text">{props.leftText}</div>
      <div className="right-text">{props.rightText}</div>
    </div>
  );
};
